import React, { useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import Modal from '../Components/Modal';
import { motion } from 'framer-motion';
import { Link, useNavigate, useLocation } from 'react-router-dom';


function Users() {
  const [users, setUsers] = useState([]);
  // eslint-disable-next-line
  const [activeSection, setActiveSection] = useState('#users');
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    contact_number: '',
    role: '',
    password: '',
    departments: [],
    branches: [],
    customers: [],
    user_permissions: [], 
  });
  
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false); 
  const [showUpdateModal, setShowUpdateModal] = useState(false); 
  const [currentUserId, setCurrentUserId] = useState(null); 
  const [showDetailsModal, setShowDetailsModal] = useState(false); 
  const [selectedUser , setSelectedUser ] = useState(null);
  const [currentUser , setCurrentUser ] = useState(null); 
  const [roles, setRoles] = useState([]);
  const [userDepartmentBranch, setUserDepartmentBranch] = useState([])
  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [userDepartments, setUserDepartments] = useState([]);
  const [userBranches, setUserBranches] = useState([]);
  const [customers, setCustomers] = useState([]);
  const isInsuranceSelected = departments.find(d => d.name.toLowerCase() === 'insurance' && formData.departments.includes(d.id));
  const [searchTerm, setSearchTerm] = useState('');
  const [activePath, setActivePath] = useState('');
  const [departmentsOpen, setDepartmentsOpen] = useState(false);

  const filteredCustomers = customers.filter((customer) =>
    customer.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showCustomerUpdateModal, setShowCustomerUpdateModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const customersPerPage = 20;
  
  const totalPages = Math.ceil(customers.length / customersPerPage);
  const indexOfLastCustomer = currentPage * customersPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - customersPerPage;
  const [currentCustomerPage, setCurrentCustomerPage] = useState(1);

  const totalCustomerPages = Math.ceil(filteredCustomers.length / customersPerPage);
  const startIndex = (currentCustomerPage - 1) * customersPerPage;
  const endIndex = startIndex + customersPerPage;
  const currentCustomers = filteredCustomers.slice(startIndex, endIndex);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [showPermissionUpdateModal, setShowPermissionUpdateModal] = useState(false);
  const [rolePermissionPreview, setRolePermissionPreview] = useState([]);
  const [permissions, setPermissions] = useState([]);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Add Details');
    const [activeUpdateTab, setActiveUpdateTab] = useState('details');
    const [documentTypes, setDocumentTypes] = useState([]);
const [userDocumentTypes, setUserDocumentTypes] = useState([]);
const [assignedDocumentTypes, setAssignedDocumentTypes] = useState([]);
const [otpSent, setOtpSent] = useState(false);
const [otp, setOtp] = useState('');
const [newPassword, setNewPassword] = useState('');
const [otpMessage, setOtpMessage] = useState('');
const [otpError, setOtpError] = useState('');

 
  const groupedPermissions = {
    "User Permissions": [1, 2, 3, 4, 5, 6],
    "Permission Management": [7, 8, 9, 10],
    "Document Permissions": [11, 12, 13, 14, 15, 16],
    "Branch Permissions": [17, 18, 19, 21],
    "Document Type Permissions": [20],
    "Customer Permissions": [22, 23, 24, 25, 26, 27],
    "Policy Permissions": [28, 29, 30, 31, 32],
    "Department Permissions": [33]
  };

  const categorizedPermissions = Object.entries(groupedPermissions).map(([category, ids]) => {
    return {
      category,
      permissions: permissions.filter(p => ids.includes(p.id))
    };
  });
  
  function parsePermissionName(name) {
    const actionMap = {
      create: 'create',
      update: 'update',
      edit: 'update',
      delete: 'delete',
      view: 'view',
      see: 'view',
      download: 'view',
      add: 'create',
      submit: 'create',
    };
  
    const lower = name.toLowerCase();
    const action = Object.keys(actionMap).find(key => lower.includes(key));
    const cleaned = name.replace(/(Create|Update|Add|Delete|Edit|View|Submit|See|Download)/gi, '').trim();
    return {
      action: actionMap[action] || null,
      module: cleaned,
    };
  }

  useEffect(() => {
    axiosInstance.get('/permissions/')
      .then(response => {
        const parsed = response.data.map(p => {
          const { action, module } = parsePermissionName(p.name);
          return {
            ...p,
            action,
            module,
          };
        });
        setPermissions(parsed);
      })
      .catch(error => {
        console.error("Error fetching permissions:", error);
      });
  }, []);

  
  useEffect(() => {
    axiosInstance.get('/user/')
      .then(response => {
        const allUsers = response.data;
        setUsers(allUsers); 
      })
      .catch(error => {
        console.error(error);
      });


      const userId = localStorage.getItem('id'); 
      if (userId) {
        axiosInstance.get(`/user/${userId}/`)
          .then(response => {
            setCurrentUser (response.data);
          })
          .catch(error => {
            console.error("Error fetching user details:", error);
          });
      }

      const selectedUserId = localStorage.getItem("selectedUserId");
      if (selectedUserId) {
        axiosInstance.get(`/user-departments-branches/${selectedUserId}/`)
        .then(response => {
          setUserDepartments(response.data.departments || []);
          setUserBranches(response.data.branches || []);
        })
        .catch(error => {
          console.error("Error fetching departments and branches:", error);
        });
      }

  axiosInstance.get('/roles/')
    .then(response => {
      setRoles(response.data);
    })
    .catch(error => {
      console.error("Error fetching roles:", error);
    });

    axiosInstance.get('/user-departments-branches/')
    .then(response => {
      setUserDepartmentBranch(response.data);
    })
    .catch(error => {
      console.error("Error fetching data:", error);
    });

    axiosInstance.get('/department/')
    .then(response => {
      setDepartments(response.data);
    })
    .catch(error => {
      console.error("Error fetching departments:", error);
    });

    axiosInstance.get('/branch/')
    .then(response => {
      setBranches(response.data);
    })
    .catch(error => {
      console.error("Error fetching branches:", error);
    });

    axiosInstance.get('/customers/')
    .then(response => {
      setCustomers(response.data);
    })
    .catch(error => {
      console.error("Error fetching customers:", error);
    });
    
  }, []);

  useEffect(() => {
    axiosInstance.get('document-types/')
      .then(res => setDocumentTypes(res.data))
      .catch(err => console.error(err));
  }, []);

  const selectedUserId = localStorage.getItem("selectedUserId");
  
  useEffect(() => {
    if (!selectedUserId || !showModal) return;
  
    axiosInstance
      .get(`/user-document-types/${selectedUserId}/`)
      .then(res => {
        const ids = res.data.map(d => d.document_type_id.toString());
  
        setFormData(prev => ({
          ...prev,
          document_types: ids,
        }));
  
        setAssignedDocumentTypes(ids);
      })
      .catch(err => {
        console.error('Failed to load document types', err);
      });
  }, [selectedUserId, showModal]);
  
  const documentTypeMap = documentTypes.reduce((acc, doc) => {
    acc[doc.category] = acc[doc.category] || [];
    acc[doc.category].push(doc);
    return acc;
  }, {});
  
  const toggleDocumentType = (id) => {
    setFormData(prev => ({
      ...prev,
      document_types: prev.document_types.includes(id)
        ? prev.document_types.filter(d => d !== id)
        : [...prev.document_types, id],
    }));
  };
  
  const handleSidebarClick = (event) => {
    const target = event.target.getAttribute('href');
    setActiveSection(target);
    const breadcrumbPath = target.replace('#', '').split('-');
    setBreadcrumb(breadcrumbPath.map((path, index) => {
      return {
        name: path.charAt(0).toUpperCase() + path.slice(1),
        link: breadcrumbPath.slice(0, index + 1).join('-').replace(/\b\w/g, l => l.toUpperCase())
      };
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "role") {
      const selectedRole = roles.find(role => role.id.toString() === value);
      const isAdminType = selectedRole && ['admin', 'subadmin'].includes(selectedRole.name.toLowerCase());
  
      setFormData(prev => ({
        ...prev,
        role: value,
        ...(isAdminType ? { departments: [], branches: [] } : {})
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
  
    axiosInstance.post('/register/', formData)
      .then(response => {
        const newUserId = response.data.id;
  
        // Assign departments & branches
        const assignDepartments = axiosInstance.post('/assign-department-branch/', {
          user_id: newUserId,
          department_ids: formData.departments,
          branch_ids: formData.branches,
        });
  
        // Assign customers
        const assignCustomers = axiosInstance.post('/assign-customer/', {
          user_id: newUserId,
          customer_ids: formData.customers,
        });
  
        // Assign permissions
        const assignPermissions = axiosInstance.post('/grant-user-permission/', {
          user_id: newUserId,
          permission_ids: (formData.user_permissions || []).filter(id => !isNaN(id)),
        });
  
        // Assign document types
        const assignDocumentTypes = axiosInstance.post(`/assign-document-type/${newUserId}/`, {
          document_types: userDocumentTypes.map(id => parseInt(id)), // send IDs as integers
        });
  
        // Wait for all assignments to finish
        return Promise.all([assignDepartments, assignCustomers, assignPermissions, assignDocumentTypes]);
      })
      .then(() => {
        setMessage('User registered and all assignments successful!');
        setShowModal(false);
        window.location.reload();
      })
      .catch(error => {
        const errorMessages = error.response?.data
          ? Object.values(error.response.data).flat().join(', ')
          : 'An error occurred. Please try again.';
        setMessage(errorMessages);
      });
  };
  
  
  
  const handleAssignAllBranches = (departmentId) => {
    const department = departments.find((d) => d.id === departmentId);
    const deptBranches = groupedBranches[department?.name] || [];
    const allBranchIds = deptBranches.map((branch) => branch.id);
  
    setFormData((prevFormData) => ({
      ...prevFormData,
      departments: [...new Set([...prevFormData.departments, departmentId])],
      branches: [...new Set([...prevFormData.branches, ...allBranchIds])],
    }));
  };  

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // 1️⃣ Update basic user info
      const userPayload = {
        email: formData.email,
        contact_number: formData.contact_number,
        first_name: formData.first_name,
        last_name: formData.last_name,
        role: formData.role,
        // password: formData.password,
      };
      await axiosInstance.put(`/user/${currentUserId}/`, userPayload);
  
      // 2️⃣ Update departments & branches
      const deptBranchPayload = {
        user_id: currentUserId,
        department_ids: formData.departments,
        branch_ids: formData.branches,
      };
      await axiosInstance.put(`/update-departments-branches/`, deptBranchPayload);
  
      // 3️⃣ Assign customers
      const customersPayload = {
        user_id: currentUserId,
        customer_ids: formData.customers,
      };
      await axiosInstance.post(`/assign-customer/`, customersPayload);
  
      // 4️⃣ Assign or update permissions
      if (formData.user_permissions && formData.user_permissions.length > 0) {
        const permissionPayload = {
          user_id: currentUserId,
          permission_ids: formData.user_permissions.map(id => Number(id)),
        };
        await axiosInstance.post(`/assign-or-update-permissions/`, permissionPayload);
      }
  
      // 5️⃣ Assign/unassign document types
      const docTypesPayload = {
        document_types: userDocumentTypes.map(id => Number(id)), // send as integers
      };
      await axiosInstance.put(`/unassign-document-type/${currentUserId}/`, docTypesPayload);
  
      // ✅ Update local state
      setMessage('User updated successfully including permissions and document types!');
      setShowUpdateModal(false);
      setUsers(users.map(user =>
        user.id === currentUserId ? { ...user, ...formData } : user
      ));
    } catch (error) {
      console.error("Error in update:", error);
      if (error.response?.data) {
        const errorMessages = Object.entries(error.response.data)
          .map(([key, value]) => Array.isArray(value) ? value.join(', ') : value)
          .join(', ');
        setMessage(errorMessages);
      } else {
        setMessage('An error occurred. Please try again.');
      }
    }
  };
  
  
  
  
  
  const handleUpdateAssignAllBranches = async (departmentId) => {
    try {
      const res = await axiosInstance.post('/assign-all-branches/', {
        user_id: currentUserId,
        department_ids: [departmentId]
      });
  
      const assignedBranchIds = res.data.branches.map(branch => String(branch.id));
      setFormData(prev => ({
        ...prev,
        departments: [...new Set([...prev.departments, String(departmentId)])],
        branches: [...new Set([...prev.branches, ...assignedBranchIds])]
      }));
    } catch (error) {
      console.error("Assign all branches failed", error);
    }
  };
  
  const handleUnassignAllBranches = async (departmentId, branchObjects) => {
    try {
      const branchIds = branchObjects.map(branch => branch.id);
  
      await axiosInstance.post('/unassign-departments-branches/', {
        user_id: currentUserId,
        department_ids: [],
        branch_ids: branchIds
      });
  
      setFormData(prev => ({
        ...prev,
        branches: prev.branches.filter(id => !branchIds.map(String).includes(id))
      }));
    } catch (error) {
      console.error("Unassign all branches failed", error);
    }
  };
  
  const openUpdateModal = (user) => {
    setFormData({
      email: user.email || '',
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      contact_number: user.contact_number || '',
      role: user.role || '',
      departments: [],
      branches: [],
      customers: [],
      user_permissions: [],      // your existing permissions
    });
  
    setUserDocumentTypes([]);   // reset document types
    setCurrentUserId(user.id);
    setShowUpdateModal(true);
  
    localStorage.setItem("selectedUserId", user.id);
  
    // Fetch departments & branches
    axiosInstance.get(`/user-departments-branches/${user.id}/`)
      .then(response => {
        const departmentIds = response.data.departments.map(dep => String(dep.id));
        const branchIds = response.data.branches.map(branch => String(branch.id));
  
        setFormData(prev => ({
          ...prev,
          departments: departmentIds,
          branches: branchIds,
        }));
      })
      .catch(error => {
        console.error("Error fetching user departments/branches:", error);
      });
  
    // Fetch assigned document types
    axiosInstance.get(`/user-document-types/${user.id}/`)
      .then(response => {
        // Map to strings for comparison in your render
        const docTypeIds = response.data.map(doc => String(doc.document_type_id));
        setUserDocumentTypes(docTypeIds);
      })
      .catch(error => {
        console.error("Error fetching user document types:", error);
      });
  
    // Fetch assigned permissions
    axiosInstance.get(`/user-permissions/${user.id}/`)
      .then(response => {
        const permIds = response.data.map(p => p.id);
        setFormData(prev => ({
          ...prev,
          user_permissions: permIds,
        }));
      })
      .catch(error => {
        console.error("Error fetching user permissions:", error);
      });
  };
  

  const handleSendOTP = async () => {
    setOtpMessage('');
    setOtpError('');
  
    const contactNumber = localStorage.getItem('contact_number');
  
    if (!contactNumber) {
      setOtpError('Contact number not found. Please login again.');
      return;
    }
  
    try {
      const res = await axiosInstance.post('/forget-password/', {
        contact_number: contactNumber,
      });
  
      if (res.data.message) {
        setOtpSent(true);
        setOtpMessage(res.data.message);
      }
    } catch (err) {
      setOtpError(err.response?.data?.error || 'Failed to send OTP');
    }
  };
    
  const handleResetPassword = async () => {
    setOtpMessage('');
    setOtpError('');
  
    const adminContact = localStorage.getItem('contact_number');
    const targetUserId = localStorage.getItem('selectedUserId');
  
    if (!adminContact) {
      setOtpError('Admin contact not found. Please login again.');
      return;
    }
  
    if (!targetUserId) {
      setOtpError('No target user selected');
      return;
    }
  
    if (!otp || !newPassword) {
      setOtpError('OTP and new password are required');
      return;
    }
  
    try {
      const res = await axiosInstance.post('/admin-reset-password/', {
        admin_contact: adminContact,
        otp,
        target_user_id: Number(targetUserId),
        new_password: newPassword,
      });
  
      if (res.data.message) {
        setOtpMessage(res.data.message);
        setOtpSent(false);
        setOtp('');
        setNewPassword('');
      }
    } catch (err) {
      setOtpError(err.response?.data?.error || 'Failed to reset password');
    }
  };
  
  
  
  
  

  const openDetailsModal = (user) => {
    console.log("Opening details modal for user:", user);
    setSelectedUser (user);
    setShowDetailsModal(true);
  };

  const handleDelete = (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      axiosInstance.delete(`/user/${userId}/`)
        .then(response => {
          setMessage('User  deleted successfully!');
          setUsers(users.filter(user => user.id !== userId));
        })
        .catch(error => {
          if (error.response.data) {
            const errorMessages = Object.keys(error.response.data).map(key => {
              return error.response.data[key].join(', ');
            }).join(', ');
            setMessage(errorMessages);
          } else {
            setMessage('An error occurred. Please try again.');
          }
        });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  };

const groupedBranches = branches.reduce((acc, branch) => {
  const dept = branch.department_name || 'Other';
  if (!acc[dept]) acc[dept] = [];
  acc[dept].push(branch);
  return acc;
}, {});

const selectedRole = roles.find(role => role.id.toString() === formData.role?.toString());
const isAdminType = selectedRole && ['admin', 'subadmin'].includes(selectedRole.name.toLowerCase());

const selectedRoleObj = roles.find(r => r.id === parseInt(formData.role));
const isHighPrivilegeRole = selectedRoleObj?.name?.toLowerCase() === 'admin' || selectedRoleObj?.name?.toLowerCase() === 'subadmin';

const renderPermissionTable = () => {
  const categorizedModules = {
    HR: ['Document', 'Branch'],
    Insurance: ['Customer', 'Policy'],
  };

  const specialRules = {
    BGV: { allow: [] },
    Department: { allow: ['create'] },
    'Document Type': { forceCategory: 'Other', allow: ['create'], label: 'Document Type' },
  };

  const skipModules = ['Permission', 'User', 'Role'];
  const categorized = {};

  permissions.forEach(p => {
    const rawName = p.name.toLowerCase();
    let action =
      rawName.includes('view') || rawName.includes('see') || rawName.includes('download')
        ? 'view'
        : rawName.includes('create') || rawName.includes('add')
        ? 'create'
        : rawName.includes('update') || rawName.includes('edit')
        ? 'update'
        : rawName.includes('delete')
        ? 'delete'
        : rawName.includes('submit')
        ? 'submit'
        : null;

    let module = p.name;

    if (rawName.includes('add document type')) {
      module = 'Document Type';
    } else if (rawName.includes('document') && !rawName.includes('type')) {
      module = 'Document';
    } else {
      module = p.name
        .replace(/(create|add|view|see|download|edit|update|delete|submit)/gi, '')
        .trim()
        .split(' ')[0];
    }

    const rule = specialRules[module] || {};
    const category =
      rule.forceCategory ||
      Object.entries(categorizedModules).find(([_, list]) => list.includes(module))?.[0] ||
      'Other';

    if (!categorized[category]) categorized[category] = {};
    if (!categorized[category][module]) categorized[category][module] = { actions: {}, others: [] };

    if (action && (!rule.allow || rule.allow.includes(action))) {
      categorized[category][module].actions[action] = p;
    } else {
      categorized[category][module].others.push(p);
    }
  });

  if (categorized['Other']) {
    Object.keys(categorized['Other']).forEach(module => {
      if (skipModules.includes(module)) delete categorized['Other'][module];
    });
  }


return (
  <>
    {Object.entries(categorized)
      .sort(([a], [b]) => {
        const order = ['HR', 'Insurance', 'Other'];
        return order.indexOf(a) - order.indexOf(b);
      })
      .map(([category, modules]) => (
        <div key={category} style={{ marginBottom: '40px' }}>
          {/* Category Header */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#111827',
              color: '#fff',
              padding: '12px 18px',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '15px',
              marginBottom: '18px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
            }}
          >
            <span>{category}</span>
          </div>

          {/* For HR & Insurance → Table Layout */}
          {category !== 'Other' ? (
            <div
              style={{
                overflowX: 'auto',
                borderRadius: '10px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                background: '#fff',
              }}
            >
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '13.5px',
                  color: '#333',
                }}
              >
                <thead>
                  <tr style={{ background: '#f5f5f5', textAlign: 'center' }}>
                    <th
                      style={{
                        textAlign: 'left',
                        padding: '12px 16px',
                        fontWeight: '600',
                        color: '#111827',
                        borderBottom: '2px solid #eee',
                      }}
                    >
                      Module
                    </th>
                    {['View', 'Create', 'Update', 'Delete'].map(act => (
                      <th
                        key={act}
                        style={{
                          padding: '12px',
                          textTransform: 'capitalize',
                          borderBottom: '2px solid #eee',
                          fontWeight: '600',
                          color: '#111827',
                        }}
                      >
                        {act}
                      </th>
                    ))}
                    {category === 'Insurance' && (
                      <th
                        style={{
                          padding: '12px',
                          borderBottom: '2px solid #eee',
                          fontWeight: '600',
                          color: '#111827',
                        }}
                      >
                        Update Doc
                      </th>
                    )}
                    <th
                      style={{
                        padding: '12px',
                        borderBottom: '2px solid #eee',
                        fontWeight: '600',
                        color: '#111827',
                      }}
                    >
                      Others
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(modules).map(([module, { actions, others }], idx) => (
                    <tr
                      key={module}
                      style={{
                        backgroundColor: idx % 2 === 0 ? '#fafafa' : '#fff',
                        borderBottom: '1px solid #eee',
                        transition: 'background 0.2s ease',
                      }}
                      onMouseEnter={e =>
                        (e.currentTarget.style.backgroundColor = '#f9f9f9')
                      }
                      onMouseLeave={e =>
                        (e.currentTarget.style.backgroundColor =
                          idx % 2 === 0 ? '#fafafa' : '#fff')
                      }
                    >
                      {/* Module Name */}
                      <td style={{ padding: '10px 16px', fontWeight: '500' }}>
                        {specialRules[module]?.label || module}
                      </td>

                      {/* Standard Actions */}
                      {['view', 'create', 'update', 'delete'].map(action => {
                        const perm = actions[action];
                        const isChecked =
                          perm && formData.user_permissions.includes(perm.id.toString());
                        return (
                          <td key={action} style={{ textAlign: 'center', padding: '10px' }}>
                            {perm ? (
                              <div
                                onClick={() => {
                                  setFormData(prev => {
                                    const updated = isChecked
                                      ? prev.user_permissions.filter(
                                          id => id !== perm.id.toString()
                                        )
                                      : [...prev.user_permissions, perm.id.toString()];
                                    return { ...prev, user_permissions: updated };
                                  });
                                }}
                                style={{
                                  width: '22px',
                                  height: '22px',
                                  borderRadius: '6px',
                                  border: '1.6px solid #ccc',
                                  backgroundColor: isChecked ? '#111827' : '#fff',
                                  color: isChecked ? '#fff' : '#111827',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s',
                                  margin: 'auto',
                                }}
                              >
                                {isChecked && (
                                  <i className="fa fa-check" style={{ fontSize: '11px' }} />
                                )}
                              </div>
                            ) : (
                              <span style={{ color: '#ccc' }}>—</span>
                            )}
                          </td>
                        );
                      })}

                      {/* Insurance Special Case */}
                      {category === 'Insurance' && (
                        <td style={{ textAlign: 'center', padding: '10px' }}>
                          {['Customer', 'Policy'].includes(module) ? (() => {
                            const perm = permissions.find(p =>
                              module === 'Customer'
                                ? p.name === 'Update Customer Doc'
                                : p.name === 'Update Policy Doc'
                            );
                            const isChecked =
                              perm && formData.user_permissions.includes(perm.id.toString());
                            return perm ? (
                              <div
                                onClick={() => {
                                  setFormData(prev => {
                                    const updated = isChecked
                                      ? prev.user_permissions.filter(
                                          id => id !== perm.id.toString()
                                        )
                                      : [...prev.user_permissions, perm.id.toString()];
                                    return { ...prev, user_permissions: updated };
                                  });
                                }}
                                style={{
                                  width: '22px',
                                  height: '22px',
                                  borderRadius: '6px',
                                  border: '1.6px solid #ccc',
                                  backgroundColor: isChecked ? '#111827' : '#fff',
                                  color: isChecked ? '#fff' : '#111827',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s',
                                  margin: 'auto',
                                }}
                              >
                                {isChecked && (
                                  <i className="fa fa-check" style={{ fontSize: '11px' }} />
                                )}
                              </div>
                            ) : (
                              <span style={{ color: '#ccc' }}>—</span>
                            );
                          })() : (
                            <span style={{ color: '#ccc' }}>—</span>
                          )}
                        </td>
                      )}

                      {/* Others */}
                      <td style={{ textAlign: 'center', padding: '10px' }}>
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '6px',
                            justifyContent: 'center',
                          }}
                        >
                          {others.map(perm => {
                            const isChecked = formData.user_permissions.includes(
                              perm.id.toString()
                            );
                            return (
                              <div
                                key={perm.id}
                                onClick={() => {
                                  setFormData(prev => ({
                                    ...prev,
                                    user_permissions: isChecked
                                      ? prev.user_permissions.filter(id => id !== perm.id.toString())
                                      : [...prev.user_permissions, perm.id.toString()],
                                  }));
                                }}
                                style={{
                                  padding: '5px 10px',
                                  border: '1px solid #ccc',
                                  borderRadius: '6px',
                                  backgroundColor: isChecked ? '#111827' : '#fff',
                                  color: isChecked ? '#fff' : '#111827',
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s',
                                }}
                              >
                                {perm.name}
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            // OTHER CATEGORY — clean chip grid
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                background: '#f9fafb',
                padding: '12px',
                borderRadius: '10px',
                border: '1px solid #eee',
                boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
              }}
            >
              {Object.entries(modules).flatMap(([module, { actions, others }]) => {
                const allPerms = [...Object.values(actions), ...others];
                return allPerms.map(perm => {
                  const isChecked = formData.user_permissions.includes(perm.id.toString());
                  return (
                    <div
                      key={perm.id}
                      onClick={() => {
                        setFormData(prev => ({
                          ...prev,
                          user_permissions: isChecked
                            ? prev.user_permissions.filter(id => id !== perm.id.toString())
                            : [...prev.user_permissions, perm.id.toString()],
                        }));
                      }}
                      style={{
                        padding: '7px 14px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        backgroundColor: isChecked ? '#111827' : '#fff',
                        color: isChecked ? '#fff' : '#111827',
                        fontSize: '13px',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                    >
                      {perm.name}
                    </div>
                  );
                });
              })}
            </div>
          )}
        </div>
      ))}

    {/* 🔽 DOCUMENT TYPES — ALWAYS LAST */}
    <div style={{ marginBottom: '40px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#111827',
          color: '#fff',
          padding: '12px 18px',
          borderRadius: '8px',
          fontWeight: 600,
          fontSize: '15px',
          marginBottom: '18px',
        }}
      >
        <span>Document Types</span>
      </div>

      <div
        style={{
          background: '#fff',
          borderRadius: '10px',
          padding: '14px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {Object.entries(
            documentTypes.reduce((acc, d) => {
              acc[d.category] = acc[d.category] || [];
              acc[d.category].push(d);
              return acc;
            }, {})
          ).map(([category, docs]) => (
            <div key={category}>
              <div
                style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  marginBottom: '6px',
                  color: '#374151',
                }}
              >
                {category}
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {docs.map(doc => {
                  const isChecked = userDocumentTypes.includes(doc.id.toString());
                  return (
                    <div
                      key={doc.id}
                      onClick={() =>
                        setUserDocumentTypes(prev =>
                          isChecked
                            ? prev.filter(id => id !== doc.id.toString())
                            : [...prev, doc.id.toString()]
                        )
                      }
                      style={{
                        padding: '6px 12px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        backgroundColor: isChecked ? '#111827' : '#fff',
                        color: isChecked ? '#fff' : '#111827',
                        fontSize: '13px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                    >
                      {doc.name}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
);
};





const renderDepartmentBranchSection = () => (
  <div
    className="form-group"
    style={{
      marginTop: '40px',
      fontFamily: 'Inter, system-ui, sans-serif',
      color: '#1f1f1f',
    }}
  >
    {/* Header */}
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: '10px',
        padding: '14px 20px',
        fontWeight: 600,
        fontSize: '14px',
        color: '#111827',
      }}
    >
      <div>Departments</div>
      <div>
        Branches / Customers{' '}
        <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 400 }}>
          (Click "All" to assign all)
        </span>
      </div>
    </div>

    {/* Department Cards */}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
        gap: '20px',
        marginTop: '20px',
      }}
    >
      {departments.map(dept => {
        const isDeptChecked = formData.departments.includes(dept.id);
        const deptBranches = groupedBranches[dept.name] || [];
        const isInsuranceDept = dept.name === 'Insurance';

        return (
          <div
            key={dept.id}
            style={{
              background: '#fff',
              borderRadius: '10px',
              border: isDeptChecked ? '1.5px solid #0f172a' : '1px solid #e5e7eb',
              boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
              transition: 'all 0.3s ease',
              overflow: 'hidden',
            }}
          >
            {/* Department Header */}
            <div
              onClick={() => {
                const newDepartments = isDeptChecked
                  ? formData.departments.filter(id => id !== dept.id)
                  : [...formData.departments, dept.id];

                setFormData({ ...formData, departments: newDepartments });

                if (isInsuranceDept && !isDeptChecked) {
                  setShowCustomerModal(true);
                }
              }}
              style={{
                backgroundColor: isDeptChecked ? '#0f172a' : '#f3f4f6',
                color: isDeptChecked ? '#fff' : '#111827',
                padding: '12px 16px',
                fontWeight: 600,
                cursor: 'pointer',
                textAlign: 'center',
                borderBottom: '1px solid #e5e7eb',
                transition: 'all 0.3s',
              }}
            >
              {dept.name}
            </div>

            {/* Branch List */}
            {deptBranches.length > 0 && (
              <div
                style={{
                  padding: '14px 16px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                }}
              >
                {/* All Button */}
                <div
                  onClick={() => handleAssignAllBranches(dept.id)}
                  style={{
                    padding: '8px 14px',
                    borderRadius: '20px',
                    backgroundColor: '#f3f4f6',
                    border: '1px solid #d1d5db',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.background = '#e5e7eb')}
                  onMouseLeave={e => (e.currentTarget.style.background = '#f3f4f6')}
                >
                  All
                </div>

                {/* Branches */}
                {deptBranches.map(branch => {
                  const isBranchChecked = formData.branches.includes(branch.id);
                  return (
                    <div
                      key={branch.id}
                      onClick={() =>
                        setFormData({
                          ...formData,
                          branches: isBranchChecked
                            ? formData.branches.filter(id => id !== branch.id)
                            : [...formData.branches, branch.id],
                        })
                      }
                      style={{
                        padding: '8px 14px',
                        borderRadius: '20px',
                        backgroundColor: isBranchChecked ? '#0f172a' : '#fff',
                        color: isBranchChecked ? '#fff' : '#111827',
                        border: isBranchChecked
                          ? '1px solid #0f172a'
                          : '1px solid #d1d5db',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: 500,
                        transition: 'all 0.3s ease',
                      }}
                    >
                      {branch.name}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>

    {/* Insurance Customers */}
    {showCustomerModal && (
      <div
        style={{
          marginTop: '40px',
          backgroundColor: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: '10px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        <h3
          style={{
            fontWeight: 600,
            marginBottom: '18px',
            fontSize: '16px',
            color: '#0f172a',
          }}
        >
          Select Insurance Customers
        </h3>

        {/* Search + Select All */}
        <div
          style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '18px',
          }}
        >
          <input
            type="text"
            placeholder="Search customers..."
            value={searchTerm}
            onChange={e => {
              setSearchTerm(e.target.value);
              setCurrentCustomerPage(1);
            }}
            style={{
              flex: 1,
              padding: '10px 14px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
            }}
          />
          <button
            onClick={() => {
              const allCustomerIds = customers.map(c => c.id.toString());
              setFormData(prev => ({
                ...prev,
                customers: allCustomerIds,
              }));
            }}
            style={{
              backgroundColor: '#0f172a',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 16px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
            }}
          >
            Select All
          </button>
        </div>

        {/* Customer Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
            gap: '12px',
          }}
        >
          {currentCustomers.map(customer => {
            const isChecked = formData.customers.includes(customer.id.toString());
            return (
              <div
                key={customer.id}
                onClick={() =>
                  setFormData(prev => ({
                    ...prev,
                    customers: isChecked
                      ? prev.customers.filter(id => id !== customer.id.toString())
                      : [...prev.customers, customer.id.toString()],
                  }))
                }
                style={{
                  padding: '12px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  backgroundColor: isChecked ? '#0f172a' : '#f9fafb',
                  color: isChecked ? '#fff' : '#111827',
                  border: isChecked ? '1px solid #0f172a' : '1px solid #e5e7eb',
                  fontSize: '13px',
                  fontWeight: 500,
                  transition: 'all 0.3s ease',
                }}
              >
                {customer.name}
              </div>
            );
          })}
        </div>

        {/* Pagination */}
        <div
          style={{
            marginTop: '22px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <button
            onClick={() => setCurrentCustomerPage(prev => Math.max(prev - 1, 1))}
            disabled={currentCustomerPage === 1}
            style={{
              padding: '8px 14px',
              borderRadius: '6px',
              backgroundColor: currentCustomerPage === 1 ? '#d1d5db' : '#0f172a',
              color: '#fff',
              border: 'none',
              cursor: currentCustomerPage === 1 ? 'not-allowed' : 'pointer',
            }}
          >
            Previous
          </button>

          <span style={{ fontSize: '13px', color: '#374151' }}>
            Page {currentCustomerPage} of {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentCustomerPage(prev => Math.min(prev + 1, totalPages))
            }
            disabled={currentCustomerPage === totalPages}
            style={{
              padding: '8px 14px',
              borderRadius: '6px',
              backgroundColor:
                currentCustomerPage === totalPages ? '#d1d5db' : '#0f172a',
              color: '#fff',
              border: 'none',
              cursor: currentCustomerPage === totalPages ? 'not-allowed' : 'pointer',
            }}
          >
            Next
          </button>
        </div>
      </div>
    )}
  </div>
);


const renderUpdatePermissionTable = () => {
  const categorizedModules = {
    HR: ['Document', 'Branch'],
    Insurance: ['Customer', 'Policy']
  };

  const specialRules = {
    'BGV': { allow: [] },
    'Department': { allow: ['create'] },
    'Document Type': { forceCategory: 'Other', allow: ['create'], label: 'Document Type' }
  };

  const skipModules = ['Permission', 'User', 'Role'];

  const categorized = {};

  permissions.forEach(p => {
    const rawName = p.name.toLowerCase();
    let action =
      rawName.includes('view') || rawName.includes('see') || rawName.includes('download') ? 'view' :
      rawName.includes('create') || rawName.includes('add') ? 'create' :
      rawName.includes('update') || rawName.includes('edit') ? 'update' :
      rawName.includes('delete') ? 'delete' :
      rawName.includes('submit') ? 'submit' : null;

    let module = p.name;

    if (rawName.includes('add document type')) {
      module = 'Document Type';
    } else if (rawName.includes('document') && !rawName.includes('type')) {
      module = 'Document';
    } else {
      module = p.name
        .replace(/(create|add|view|see|download|edit|update|delete|submit)/gi, '')
        .trim()
        .split(' ')[0];
    }

    const rule = specialRules[module] || {};
    const category =
      rule.forceCategory ||
      Object.entries(categorizedModules).find(([_, list]) => list.includes(module))?.[0] ||
      'Other';

    if (!categorized[category]) categorized[category] = {};
    if (!categorized[category][module]) categorized[category][module] = { actions: {}, others: [] };

    if (action && (!rule.allow || rule.allow.includes(action))) {
      categorized[category][module].actions[action] = p;
    } else {
      categorized[category][module].others.push(p);
    }
  });

  if (categorized['Other']) {
    Object.keys(categorized['Other']).forEach(module => {
      if (skipModules.includes(module)) delete categorized['Other'][module];
    });
  }

  return (
    <>
      <div className="doc">
        <h2 style={{ fontWeight: 700, color: '#0f172a', marginBottom: '4px' }}>
          Assign Permissions to This User
        </h2>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          These are default permissions based on the selected role. You can modify them below.
        </p>
      </div>

      {Object.entries(categorized)
        .sort(([a], [b]) => {
          const order = ['HR', 'Insurance', 'Other'];
          return order.indexOf(a) - order.indexOf(b);
        })
        .map(([category, modules]) => (
          <div key={category} style={{ marginBottom: '40px', background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', boxShadow: '0 2px 6px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
            {/* Header */}
            <div style={{ marginBottom: '10px', backgroundColor: '#000', borderRadius: '12px', padding: '12px 20px', fontWeight: 600, color: '#fff', fontSize: '15px' }}>
              {category}
            </div>

            {/* HR & Insurance Table */}
            {category !== 'Other' ? (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f3f4f6', color: '#111827' }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left' }}>Module</th>
                    {['view', 'create', 'update', 'delete'].map(act => (
                      <th key={act} style={{ padding: '12px 8px', textTransform: 'capitalize', textAlign: 'center' }}>{act}</th>
                    ))}
                    {category === 'Insurance' && <th style={{ padding: '12px 8px', textAlign: 'center' }}>Update Doc</th>}
                    <th style={{ padding: '12px 8px', textAlign: 'center' }}>Other</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(modules).map(([module, { actions, others }]) => (
                    <tr key={module} style={{ borderTop: '1px solid #e5e7eb', transition: 'background 0.2s' }}
                      onMouseEnter={e => (e.currentTarget.style.background = '#f9fafb')}
                      onMouseLeave={e => (e.currentTarget.style.background = '#fff')}
                    >
                      <td style={{ padding: '12px 16px', fontWeight: 500, color: '#0f172a' }}>{specialRules[module]?.label || module}</td>
                      {['view', 'create', 'update', 'delete'].map(action => {
                        const perm = actions[action];
                        const isChecked = perm && formData.user_permissions.includes(perm.id);
                        return (
                          <td key={action} style={{ textAlign: 'center', padding: '10px 8px' }}>
                            {perm ? (
                              <div
                                onClick={() => {
                                  setFormData(prev => {
                                    const updated = isChecked
                                      ? prev.user_permissions.filter(id => id !== perm.id)
                                      : [...prev.user_permissions, perm.id];
                                    return { ...prev, user_permissions: updated };
                                  });
                                }}
                                style={{
                                  width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                                  border: '1.5px solid #d1d5db', borderRadius: '6px',
                                  backgroundColor: isChecked ? '#0f172a' : '#fff',
                                  color: isChecked ? '#fff' : '#0f172a',
                                  cursor: 'pointer', transition: 'all 0.2s ease', margin: 'auto'
                                }}
                              >
                                {isChecked && <i className="fa fa-check" style={{ fontSize: '12px' }} />}
                              </div>
                            ) : <span style={{ color: '#d1d5db' }}>—</span>}
                          </td>
                        );
                      })}
                      {category === 'Insurance' && (
                        <td style={{ textAlign: 'center', padding: '10px' }}>
                          {['Customer', 'Policy'].includes(module) ? (() => {
                            const perm = permissions.find(p =>
                              module === 'Customer' ? p.name === 'Update Customer Doc' : p.name === 'Update Policy Doc'
                            );
                            const isChecked = perm && formData.user_permissions.includes(perm.id);
                            return perm ? (
                              <div
                                onClick={() => {
                                  setFormData(prev => {
                                    const idNum = Number(perm.id);
                                    const already = prev.user_permissions.includes(idNum);
                                    return {
                                      ...prev,
                                      user_permissions: already
                                        ? prev.user_permissions.filter(id => id !== idNum)
                                        : [...prev.user_permissions, idNum],
                                    };
                                  });
                                }}
                                style={{
                                  width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center',
                                  border: '1.5px solid #d1d5db', borderRadius: '6px',
                                  backgroundColor: isChecked ? '#0f172a' : '#fff',
                                  color: isChecked ? '#fff' : '#0f172a',
                                  cursor: 'pointer', margin: 'auto', transition: 'all 0.2s ease'
                                }}
                              >
                                {isChecked && <i className="fa fa-check" style={{ fontSize: '12px' }} />}
                              </div>
                            ) : <span style={{ color: '#d1d5db' }}>—</span>;
                          })() : <span style={{ color: '#d1d5db' }}>—</span>}
                        </td>
                      )}
                      <td style={{ textAlign: 'center', padding: '10px' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', justifyContent: 'center' }}>
                          {others.map(perm => {
                            const isChecked = formData.user_permissions.includes(perm.id);
                            return (
                              <div
                                key={perm.id}
                                onClick={() => setFormData(prev => ({
                                  ...prev,
                                  user_permissions: isChecked
                                    ? prev.user_permissions.filter(id => id !== perm.id)
                                    : [...prev.user_permissions, perm.id]
                                }))}
                                style={{
                                  padding: '5px 8px', border: '1px solid #d1d5db', borderRadius: '6px',
                                  backgroundColor: isChecked ? '#0f172a' : '#fff',
                                  color: isChecked ? '#fff' : '#0f172a',
                                  fontSize: '12px', cursor: 'pointer', transition: 'all 0.2s ease',
                                }}
                              >
                                {perm.name}
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '10px', backgroundColor: '#fff' }}>
                {Object.entries(modules).flatMap(([module, { actions, others }]) => {
                  const allPerms = [...Object.values(actions), ...others];
                  return allPerms.map(perm => {
                    const isChecked = formData.user_permissions.includes(perm.id);
                    return (
                      <div
                        key={perm.id}
                        onClick={() => setFormData(prev => ({
                          ...prev,
                          user_permissions: isChecked
                            ? prev.user_permissions.filter(id => id !== perm.id)
                            : [...prev.user_permissions, perm.id]
                        }))}
                        style={{
                          padding: '8px 12px',
                          border: '1px solid #d1d5db',
                          borderRadius: '8px',
                          backgroundColor: isChecked ? '#0f172a' : '#fff',
                          color: isChecked ? '#fff' : '#0f172a',
                          fontSize: '13px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                      >
                        {perm.name}
                      </div>
                    );
                  });
                })}
              </div>
            )}
          </div>
        ))}

      {/* 🔽 DOCUMENT TYPES — ALWAYS LAST */}
      <div style={{ marginBottom: '40px' }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          background: '#111827', color: '#fff', padding: '12px 18px', borderRadius: '8px',
          fontWeight: 600, fontSize: '15px', marginBottom: '18px'
        }}>
          <span>Document Types</span>
        </div>

        <div style={{
          background: '#fff', borderRadius: '10px', padding: '14px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {Object.entries(
              documentTypes.reduce((acc, d) => {
                acc[d.category] = acc[d.category] || [];
                acc[d.category].push(d);
                return acc;
              }, {})
            ).map(([category, docs]) => (
              <div key={category}>
                <div style={{ fontSize: '12px', fontWeight: 600, marginBottom: '6px', color: '#374151' }}>
                  {category}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {docs.map(doc => {
                    const isChecked = userDocumentTypes.includes(doc.id.toString());
                    return (
                      <div
                        key={doc.id}
                        onClick={() => setUserDocumentTypes(prev =>
                          isChecked ? prev.filter(id => id !== doc.id.toString()) : [...prev, doc.id.toString()]
                        )}
                        style={{
                          padding: '6px 12px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          backgroundColor: isChecked ? '#111827' : '#fff',
                          color: isChecked ? '#fff' : '#111827',
                          fontSize: '13px',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                        }}
                      >
                        {doc.name}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};



const renderUpdateDepartmentBranchSection = () => (
  <>
    {!isAdminType && (
      <div className="form-row-5">
        <div className="form-group-5">
          <div className="departments-container">
            <div className="departments-header">
              <div className="header-department">Departments</div>
              <div className="header-branches">Branches / Customers</div>
            </div>

            {departments.map((dept) => {
              const isInsuranceDept = dept.name.toLowerCase() === 'insurance';
              const hasCustomers = formData.customers && formData.customers.length > 0;
              const isDeptChecked = isInsuranceDept
                ? hasCustomers || formData.departments.includes(String(dept.id))
                : formData.departments.includes(String(dept.id));

              let relatedItems = [];
              if (!isInsuranceDept && isDeptChecked) {
                relatedItems = groupedBranches[dept.name] || [];
              }

              return (
                <div key={dept.id} className="department-row">
                  <div
                    className={`custom-toggle department-toggle ${isDeptChecked ? 'selected' : ''}`}
                    onClick={() => {
                      const isSelected = formData.departments.includes(String(dept.id));
                      const hasCustomers = formData.customers && formData.customers.length > 0;

                      if (isInsuranceDept) {
                        setShowCustomerUpdateModal(true);

                        if (!isSelected) {
                          const updated = [...formData.departments, String(dept.id)];
                          setFormData({ ...formData, departments: updated });

                          axiosInstance.post('/assign-department-branch/', {
                            user_id: currentUserId,
                            department_ids: [dept.id],
                            branch_ids: []
                          }).catch(console.error);
                        } else {
                          if (!hasCustomers) {
                            axiosInstance.post('/unassign-departments-branches/', {
                              user_id: currentUserId,
                              department_ids: [dept.id],
                              branch_ids: []
                            }).then(() => {
                              const updated = formData.departments.filter(id => id !== String(dept.id));
                              setFormData({ ...formData, departments: updated });
                            }).catch(console.error);
                          } else {
                            console.warn("Cannot unassign Insurance department while customers are assigned.");
                          }
                        }
                        return;
                      }

                      if (isSelected) {
                        axiosInstance.post('/unassign-departments-branches/', {
                          user_id: currentUserId,
                          department_ids: [dept.id],
                          branch_ids: []
                        }).then(() => {
                          const updated = formData.departments.filter(id => id !== String(dept.id));
                          setFormData({ ...formData, departments: updated });
                        }).catch(console.error);
                      } else {
                        const updated = [...formData.departments, String(dept.id)];
                        setFormData({ ...formData, departments: updated });

                        axiosInstance.post('/assign-department-branch/', {
                          user_id: currentUserId,
                          department_ids: [dept.id],
                          branch_ids: []
                        }).catch(console.error);
                      }
                    }}
                  >
                    {dept.name}
                  </div>

                  <div className="custom-toggle-grid branches-container">
                    {isInsuranceDept ? (
                      <div className="no-assign-msg">(Customers available in popup)</div>
                    ) : isDeptChecked ? (
                      relatedItems.length === 0 ? (
                        <div className="no-items">No items available</div>
                      ) : (
                        <>
                          {/* Assign / Unassign All Button */}
                          {!isInsuranceDept && isDeptChecked && relatedItems.length > 0 && (
                            <div
                              className="custom-toggle"
                              style={{
                                fontWeight: 'bold',
                                border: '1px solid #666',
                                marginBottom: '6px',
                                backgroundColor: '#eee',
                              }}
                              onClick={() => {
                                const allBranchIds = relatedItems.map(b => String(b.id));
                                const allAssigned = allBranchIds.every(id => formData.branches.includes(id));
                                if (allAssigned) {
                                  handleUnassignAllBranches(dept.id, relatedItems);
                                } else {
                                  handleUpdateAssignAllBranches(dept.id);
                                }
                              }}
                            >
                              All
                            </div>
                          )}

                          {/* Individual Branch Toggle */}
                          {relatedItems.map(item => {
                            const idStr = String(item.id);
                            const isChecked = formData.branches.includes(idStr);
                            return (
                              <div
                                key={item.id}
                                className={`custom-toggle branch-toggle ${isChecked ? 'selected' : ''}`}
                                onClick={() => {
                                  if (isChecked) {
                                    axiosInstance.post('/unassign-departments-branches/', {
                                      user_id: currentUserId,
                                      department_ids: [],
                                      branch_ids: [item.id]
                                    }).then(() => {
                                      const updated = formData.branches.filter(id => id !== idStr);
                                      setFormData({ ...formData, branches: updated });
                                    }).catch(console.error);
                                  } else {
                                    axiosInstance.post('/assign-department-branch/', {
                                      user_id: currentUserId,
                                      department_ids: [],
                                      branch_ids: [item.id]
                                    }).then(() => {
                                      const updated = [...formData.branches, idStr];
                                      setFormData({ ...formData, branches: updated });
                                    }).catch(console.error);
                                  }
                                }}
                              >
                                {item.name}
                              </div>
                            );
                          })}
                        </>
                      )
                    ) : (
                      <div className="no-assign-msg">(Assign department to see branches/customers)</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    )}
  </>
);

const renderCustomerPopup = () => (
  <div>
    <div className='doc'>
      <h2>Select Insurance Customers
        <span>Assign or unassign customers under Insurance department</span>
      </h2>
    </div>
    <hr />

    {/* All Button */}
    <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'flex-end' }}>
      <button className="view-all-btn"
        onClick={() => {
          const allAssigned = customers.every(c =>
            formData.customers.includes(c.id.toString())
          );

          const endpoint = allAssigned
            ? '/unassign-all-customers/'
            : '/assign-all-customers/';

          axiosInstance.post(endpoint, { user_id: currentUserId })
            .then((res) => {
              const updatedIds = res.data.customers.map(c => c.id.toString());
              setFormData(prev => ({
                ...prev,
                customers: allAssigned ? [] : updatedIds,
              }));
            })
            .catch((err) => {
              console.error(err);
              alert("Error updating customers.");
            });
        }}
        style={{
          padding: '8px 14px',
          backgroundColor: customers.every(c =>
            formData.customers.includes(c.id.toString())
          ) ? '#000' : '#fff',
          color: customers.every(c =>
            formData.customers.includes(c.id.toString())
          ) ? '#fff' : '#000',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        All
      </button>
    </div>

    {/* Search */}
    <input
      type="text"
      placeholder="Search customers..."
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentCustomerPage(1);
      }}
      style={{
        width: '100%',
        padding: '8px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        marginBottom: '12px'
      }}
    />

    {/* Customer Grid */}
    <div
      className="customer-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '12px',
        marginBottom: '16px'
      }}
    >
      {currentCustomers.map((customer) => {
        const idStr = String(customer.id);
        const isChecked = formData.customers.includes(idStr);

        return (
          <div
            key={customer.id}
            className={`custom-toggle ${isChecked ? 'selected' : ''}`}
            onClick={() => {
              const api = isChecked ? '/unassign-customer/' : '/assign-customer/';
              axiosInstance.post(api, {
                user_id: currentUserId,
                customer_ids: [customer.id],
              })
                .then(() => {
                  setFormData(prev => ({
                    ...prev,
                    customers: isChecked
                      ? prev.customers.filter(id => id !== idStr)
                      : [...prev.customers, idStr]
                  }));
                })
                .catch(console.error);
            }}
            style={{
              padding: '10px',
              border: '1px solid #000',
              borderRadius: '6px',
              cursor: 'pointer',
              textAlign: 'center',
              backgroundColor: isChecked ? '#000' : '#fff',
              color: isChecked ? '#fff' : '#000'
            }}
          >
            {customer.name}
          </div>
        );
      })}
    </div>

    {/* Pagination */}
    <div className="pagination">
      {Array.from({ length: totalCustomerPages }, (_, i) => (
        <button
          key={i}
          className={`pagination-btn ${currentCustomerPage === i + 1 ? 'active' : ''}`}
          onClick={() => setCurrentCustomerPage(i + 1)}
        >
          {i + 1}
        </button>
      ))}
    </div>
  </div>
);



  return (
    <div className="dashboard-wrapper">
      {/* Left Sidebar */}
      <div className="dashboard-sidebar">
  <div className="sidebar-header">
    <img src="/logo.png" alt="Logo" className="sidebar-logo" />
  </div>

  <nav className="sidebar-nav">
    <Link
      to="/admin-dashboard"
      className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
    >
      <i className="fas fa-home"></i> Dashboard
    </Link>

    {currentUser?.role_name === 'admin' && (
      <Link
        to="/users"
        className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
      >
        <i className="fas fa-users"></i> Users
      </Link>
    )}

    {/* Simplified Departments Link */}
    <Link
      to="/departments"
      className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
    >
      <i className="fas fa-file-alt"></i> Departments
    </Link>
  </nav>
</div>

    <div
              className="dashboard-main"
              style={{
                display: 'flex',
                gap: '20px',
                flexWrap: 'nowrap',
                alignItems: 'flex-start',
                padding: '20px',
              }}
            >
        <div className="dashboard-content" style={{ flex: 3 }}>

<h2>Users</h2>
<div
            className="dashboard-cards"
            style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
          >
             <motion.div className="dashboard-card">
                          <div className="card-header">
                            <button className="view-all-btn" onClick={() => setShowModal(true)}>
                               + Add User
                            </button>
                          </div>
                          <table className="striped-table" style={{marginTop: "20px"}}>
  <thead>
    <tr>
      <th>Name</th>
      <th>Email</th>
      <th>Role</th>
      <th className='user-tab'>Contact</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {users.map((user, index) => (
      <tr key={index}>
        <td>{user.first_name} {user.last_name}</td>
        <td >{user.email}</td>
        <td>{user.role_name}</td>
        <td className='user-tab'>{user.contact_number}</td>
        <td>
        <i
          className="fas fa-edit"
          title="Update User"
          onClick={() => {
            localStorage.setItem("selectedUserId", user.id); 
            openUpdateModal(user);                          
          }}
          style={{ cursor: 'pointer', marginRight: '10px' }}
        ></i>
          <i className="fas fa-eye" title='View User' onClick={() => openDetailsModal(user)} style={{ cursor: 'pointer', marginRight: '10px' }}></i>
          <i className="fas fa-trash" title='Delete User' onClick={() => handleDelete(user.id)} style={{ cursor: 'pointer', marginRight: '10px' }}></i>
        </td>
      </tr>
    ))}
  </tbody>
</table>
                        </motion.div>

<Modal
  isOpen={showModal}
  onClose={() => {
    setShowModal(false);
    window.location.reload();
  }}
>
  <div style={{ display: 'flex', minHeight: '70vh' }}>
    {/* ===== SIDEBAR ===== */}
  {/* ===== SIDEBAR ===== */}
<div
  style={{
    width: '220px',
    borderRight: '1px solid #ddd',
    padding: '20px 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: '#f8f8f8',
    borderRadius: '20px',
  }}
>
  {/* Top Tabs */}
  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
    {['Add Details', 'Permissions', 'Departments & Branches'].map((tab, i) => (
      <div
        key={i}
        onClick={() => setActiveTab(tab)}
        style={{
          padding: '10px 15px',
          borderRadius: '8px',
          backgroundColor: activeTab === tab ? '#000' : 'transparent',
          color: activeTab === tab ? '#fff' : '#000',
          fontWeight: activeTab === tab ? '600' : 'normal',
          cursor: 'pointer',
          transition: '0.2s',
          fontSize: '14px',
          textAlign: 'center',
        }}
      >
        {tab}
      </div>
    ))}
  </div>

  {/* Add User Button */}
  <button className="view-all-btn"
    onClick={handleSubmit}
    // style={{
    //   marginTop: 'auto',
    //   background: '#000',
    //   color: '#fff',
    //   border: 'none',
    //   borderRadius: '8px',
    //   padding: '10px 0',
    //   fontWeight: '600',
    //   fontSize: '14px',
    //   cursor: 'pointer',
    //   transition: '0.3s ease',
    // }}
    onMouseEnter={(e) => (e.target.style.background = '#f47522')}
    onMouseLeave={(e) => (e.target.style.background = '#fff')}
  >
   Add User
  </button>
</div>


    {/* ===== MAIN CONTENT AREA ===== */}
    <div style={{ flex: 1, padding: '20px', overflowY: 'auto' }}>
      {/* ---------------- ADD DETAILS TAB ---------------- */}
      {activeTab === 'Add Details' && (
        <form onSubmit={handleSubmit}>
          <div className='doc'>
            <h2>Add User</h2>
          </div>
          <hr />

          {/* ====== User Info Fields ====== */}
          <div className="form-row">
            <div className="form-group">
              <label>Email*</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Contact Number*</label>
              <input
                type="text"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                maxLength="10"
                inputMode="numeric"
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                required
              />
            </div>

            <div className="form-group">
              <label>First Name*</label>
              <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>Last Name*</label>
              <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-row">
            {/* Role Dropdown */}
            <div className="form-group">
              <label>Role*</label>
              <select
                name="role"
                value={formData.role}
                onChange={(e) => {
                  handleChange(e);
                  const roleName = roles.find(r => r.id === parseInt(e.target.value))?.name?.toLowerCase();
                  if (roleName === 'admin' || roleName === 'subadmin') {
                    setShowPermissionModal(false);
                    setShowCustomerModal(false);
                  }
                }}
                required
                className='styled-select'
              >
                <option value="" disabled>Select role</option>
                {roles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>

            {/* Password Field */}
            <div className="form-group" style={{ position: 'relative' }}>
              <label>Password*</label>
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <i
                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                onClick={togglePasswordVisibility}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '60%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#666',
                }}
              />
            </div>
          </div>

          <hr />
          {/* <button className="view-all-btn" type="submit">Add User</button> */}
        </form>
      )}

      {/* ---------------- PERMISSIONS TAB ---------------- */}
      {activeTab === 'Permissions' && (
        <div>
          <div className="doc">
            <h2>Assign Permissions</h2>
            <span>Modify user permissions as needed.</span>
          </div>
          <hr />

          {/* reuse your permission table code here unchanged */}
          {renderPermissionTable()} {/* ← we’ll move that giant permission block into a helper function */}
        </div>
      )}

      {/* ---------------- DEPARTMENTS TAB ---------------- */}
      {activeTab === 'Departments & Branches' && (
        <div>
          <div className="doc">
            <h2>Departments & Branches</h2>
            <span>Assign departments, branches, and customers.</span>
          </div>
          <hr />

          {/* reuse your department + branches code here unchanged */}
          {renderDepartmentBranchSection()} {/* ← extracted block from your existing code */}
        </div>
      )}
    </div>
  </div>

  {message && <p>{message}</p>}
</Modal>


<Modal isOpen={showUpdateModal} onClose={() => setShowUpdateModal(false)}>
<div
    className="update-modal-container"
    style={{
      display: 'flex',
      backgroundColor: '#fff',
      borderRadius: '8px',
      overflow: 'hidden',
      minHeight: '70vh'
    }}
  >
    {/* ===== Sidebar ===== */}
    <div
      className="sidebar"
      style={{
        width: '220px',
        borderRight: '1px solid #ddd',
        padding: '20px 10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: '#f8f8f8',
        borderRadius: '20px',
      }}
    >
      {/* ===== Sidebar Tabs ===== */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {[
          { key: 'details', label: 'Update Details' },
          { key: 'permissions', label: 'Permissions' },
          { key: 'departments', label: 'Departments & Branches' },
        ].map(item => (
          <div
            key={item.key}
            onClick={() => {
              setActiveUpdateTab(item.key);

              // 🧠 Load data only when "Permissions" tab is clicked
              if (item.key === 'permissions') {
                axiosInstance.get('/role-permissions/')
                  .then((res) => {
                    const rolePerm = res.data.find(r => r.id === parseInt(formData.role));
                    if (rolePerm) setRolePermissionPreview(rolePerm.permissions);
                  });

                axiosInstance.get(`/user/${currentUserId}/`)
                  .then(res => {
                    const userPermissions = (res.data.user_permissions || []).map(id => Number(id));
                    setFormData(prev => ({ ...prev, user_permissions: userPermissions }));
                  })
                  .catch(err => console.error("Error fetching user permissions:", err));
              }
            }}
            style={{
              padding: '10px 15px',
              borderRadius: '8px',
              backgroundColor: activeUpdateTab === item.key ? '#000' : 'transparent',
              color: activeUpdateTab === item.key ? '#fff' : '#000',
              fontWeight: activeUpdateTab === item.key ? 'bold' : 'normal',
              cursor: 'pointer',
              transition: '0.2s',
              fontSize: '14px',
              textAlign: 'center',
            }}
          >
            {item.label}
          </div>
        ))}
      </div>

      {/* ===== Update Button (fixed at bottom) ===== */}
      <div
        style={{
          padding: '16px',
          borderTop: '1px solid #ddd',
          background: '#f8f8f8'
        }}
      >
        <button
          onClick={handleUpdateSubmit}
          className="view-all-btn"
          disabled={otpSent}
        >
          Update
        </button>
      </div>
    </div>
    

    {/* ===== Main Content ===== */}
    <div className="main-content" style={{ flex: 1, overflowY: 'auto', padding: '20px' }}>
      
      {/* ===== Add Details ===== */}
      {activeUpdateTab === 'details' && (
        <form onSubmit={handleUpdateSubmit}>
          <div className='doc'>
            <h2>Update User </h2>
          </div>
          <hr />

          <div className="form-row">
            <div className="form-group">
              <label>Email:</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label className='user-label'>Contact Number*</label>
              <input
                type="text"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                maxLength="10"
                inputMode="numeric"
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
              />
            </div>
            <div className="form-group">
              <label>First Name:</label>
              <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Last Name:</label>
              <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
          <div className="form-group">
  <label>New Password:</label>
  <input
    type="password"
    placeholder="Enter new password"
    value={newPassword}
    onChange={(e) => setNewPassword(e.target.value)}
    required
  />
</div>

{otpSent && (
  <div className="form-group">
    <label>OTP:</label>
    <input
      type="number"
      placeholder="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      maxLength={6}
      required
    />
  </div>
)}

<div className="form-group">
  {!otpSent ? (
    <button type="button" className="view-all-btn" onClick={handleSendOTP}>
      Send OTP
    </button>
  ) : (
    <button type="button" className="view-all-btn" onClick={handleResetPassword}>
      Reset Password
    </button>
  )}
</div>

{otpMessage && <p style={{ color: 'green' }}>{otpMessage}</p>}
{otpError && <p style={{ color: 'red' }}>{otpError}</p>}



            <div className="form-group">
              <label>Role:</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="styled-select"
                required
              >
                {roles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
          </div>

          <hr />
          {/* <button className="view-all-btn" type="submit">Update</button> */}
          {message && <p>{message}</p>}
        </form>
      )}

      {/* ===== Permissions Section ===== */}
      {activeUpdateTab === 'permissions' && (
        formData?.user_permissions && Array.isArray(formData.user_permissions) && permissions?.length > 0 ? (
          renderUpdatePermissionTable()
        ) : (
          <div style={{ padding: '20px', color: '#999' }}>Loading permissions...</div>
        )
      )}

      {/* ===== Departments & Branches Section ===== */}
      {activeUpdateTab === 'departments' && renderUpdateDepartmentBranchSection()}
    </div>
  </div>

  {/* ===== Customer Popup ===== */}
  {showCustomerUpdateModal && (
    <Modal isOpen={true} onClose={() => setShowCustomerUpdateModal(false)}>
      {renderCustomerPopup()}
    </Modal>
  )}
</Modal>




        <Modal isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)} style={{ padding: '20px' }}>
        {selectedUser  && (
    <div>
      <div className='doc'> 
        <h2>User Details 
        </h2>
        </div>  
      <hr />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
      <div style={{ margin: '5px' }}>
    <p><strong>First Name:</strong> {selectedUser .first_name}</p>
  </div>
  <div style={{ margin: '5px' }}>
    <p><strong>Last Name:</strong> {selectedUser .last_name}</p>
  </div>
  <div style={{ margin: '5px' }}>
    <p><strong>Email:</strong> {selectedUser .email}</p>
  </div>
  <div style={{ margin: '5px' }}>
    <p><strong>Contact Number:</strong> {selectedUser .contact_number}</p>
  </div>
  <div style={{ margin: '5px' }}>
    <p><strong>Role:</strong> {selectedUser .role_name}</p>
  </div>
</div>
    </div>
  )}
</Modal>


      </div>
    </div>
    </div>
    </div>
  );
}

export default Users;